// ── Mobile menu ───────────────────────────────────────────
const hamburger  = document.getElementById('hamburger');
const mobileMenu = document.getElementById('mobileMenu');
const menuClose  = document.getElementById('menuClose');

hamburger && hamburger.addEventListener('click', () => {
  mobileMenu.classList.add('open');
  document.body.style.overflow = 'hidden';
});
menuClose && menuClose.addEventListener('click', () => {
  mobileMenu.classList.remove('open');
  document.body.style.overflow = '';
});
document.querySelectorAll('.mobile-link').forEach(l => l.addEventListener('click', () => {
  mobileMenu.classList.remove('open');
  document.body.style.overflow = '';
}));

// ── Nav scroll elevation ──────────────────────────────────
const nav = document.getElementById('nav');
function updateNav() {
  if (!nav) return;
  nav.classList.toggle('nav-solid', window.scrollY > 40);
}
updateNav();

// ── Scroll reveal ─────────────────────────────────────────
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('revealed');
      revealObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));

// ── Statement — staggered word reveal ─────────────────────
const statementText = document.querySelector('.statement-text');
if (statementText) {
  const statementObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
        statementObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.35 });
  statementObserver.observe(statementText);
}

// ── Subtle parallax ───────────────────────────────────────
const parallaxEls = Array.from(document.querySelectorAll('[data-parallax]'));
function updateParallax() {
  const vh = window.innerHeight;
  parallaxEls.forEach(el => {
    const rect = el.getBoundingClientRect();
    if (rect.bottom < -100 || rect.top > vh + 100) return;   // skip offscreen
    const speed = parseFloat(el.dataset.parallax) || 0.12;
    const progress = (rect.top + rect.height / 2 - vh / 2) / vh;  // -1 .. 1
    const y = -progress * speed * 100;
    el.style.transform = `translate3d(0, ${y.toFixed(1)}px, 0) scale(1.12)`;
  });
}

// ── rAF-throttled scroll loop ─────────────────────────────
let ticking = false;
function onScroll() {
  if (ticking) return;
  ticking = true;
  requestAnimationFrame(() => {
    updateNav();
    updateParallax();
    ticking = false;
  });
}
window.addEventListener('scroll', onScroll, { passive: true });
window.addEventListener('resize', updateParallax, { passive: true });
updateParallax();

// ── Spotted gallery arrows ────────────────────────────────
const spottedTrack = document.getElementById('spottedTrack');
if (spottedTrack) {
  const spottedStep = () => {
    const card = spottedTrack.querySelector('.spotted-card');
    return card ? card.getBoundingClientRect().width + 16 : 320;
  };
  document.getElementById('spottedPrev').addEventListener('click', () =>
    spottedTrack.scrollBy({ left: -spottedStep(), behavior: 'smooth' }));
  document.getElementById('spottedNext').addEventListener('click', () =>
    spottedTrack.scrollBy({ left: spottedStep(), behavior: 'smooth' }));
}

// ── Email form ────────────────────────────────────────────
const clubForm = document.getElementById('clubForm');
if (clubForm) {
  clubForm.addEventListener('submit', (e) => {
    e.preventDefault();
    const input = clubForm.querySelector('.club-input');
    const btn   = clubForm.querySelector('.btn');
    if (!input.value || !input.validity.valid) { input.focus(); return; }
    btn.textContent = "You're in. ✓";
    btn.style.background = '#2D6A4F';
    btn.style.color = '#F4EFE6';
    btn.style.cursor = 'default';
    input.value = '';
    input.disabled = true;
    btn.disabled = true;
  });
}

/* opt-in video: unfolds inline, nothing loads until asked for */
(function () {
  function init() {
    var wraps = document.querySelectorAll('.mk-vwrap');
    if (!wraps.length) return;

    Array.prototype.forEach.call(wraps, function (wrap) {
      var btn = wrap.querySelector('[data-vtoggle]');
      var vid = wrap.querySelector('.mk-vplayer');
      if (!btn || !vid) return;

      btn.addEventListener('click', function () {
        var open = wrap.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');

        if (open) {
          var p = vid.play();
          if (p && p.catch) p.catch(function () {}); /* native control still works */
          /* keep the player in view once it has finished unfolding */
          setTimeout(function () {
            var r = wrap.getBoundingClientRect();
            if (r.bottom > window.innerHeight) {
              wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }, 520);
        } else {
          vid.pause();
        }
      });

      vid.addEventListener('ended', function () {
        wrap.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Doors have no hover on touch, so the one you have scrolled to opens itself. */
(function () {
  var doors = document.querySelectorAll('.mk-door');
  if (!doors.length || !('IntersectionObserver' in window)) return;
  var mq = window.matchMedia('(max-width: 860px)');
  var io = null;

  function start() {
    if (io) return;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        e.target.classList.toggle('is-live', e.isIntersecting);
      });
    }, { rootMargin: '-42% 0px -42% 0px', threshold: 0 });  /* middle band of the screen */
    Array.prototype.forEach.call(doors, function (d) { io.observe(d); });
  }
  function stop() {
    if (!io) return;
    io.disconnect(); io = null;
    Array.prototype.forEach.call(doors, function (d) { d.classList.remove('is-live'); });
  }
  function sync() { mq.matches ? start() : stop(); }

  sync();
  if (mq.addEventListener) mq.addEventListener('change', sync);
  else if (mq.addListener) mq.addListener(sync);
})();

/* The in-hand clip: 1.8MB that only downloads if you actually scroll to it. */
(function () {
  function init() {
    var vid = document.querySelector('.mk-clip-vid');
    if (!vid || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var p = vid.play();               /* preload="none" means play() is what fetches it */
          if (p && p.catch) p.catch(function () {});
        } else if (!vid.paused) {
          vid.pause();                      /* offscreen loops burn battery for nothing */
        }
      });
    }, { threshold: 0.25 });
    io.observe(vid);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ============================================================
   CART DRAWER  (cart-aware, no page reloads)
   ============================================================ */
(function () {
  function init() {
  var drawer = document.getElementById('cartDrawer');
  var overlay = document.getElementById('cartDrawerOverlay');
  if (!drawer || !overlay) return;

  var FS = 3500;
  var cross = [];
  try { cross = JSON.parse(document.getElementById('cd-crosssell').textContent); } catch (e) {}
  var COMPARE = {};
  try { COMPARE = JSON.parse(document.getElementById('cd-compare').textContent); } catch (e) {}
  function compareOf(item) { var c = COMPARE[item.variant_id] || 0; return c > item.price ? c : 0; }

  var lastAddedId = null;   // variant id of the most recent add, for the highlight
  var dealActive = false;   // Buy 2 Get 1 live -> show each line at the further-discounted per-tin
  var dealPer = 0;          // effective per-tin when the deal is live
  var currentCart = null;   // last rendered cart, for the quick-edit popup

  var elReward = document.getElementById('cdReward');
  var elItems = document.getElementById('cdItems');
  var elCross = document.getElementById('cdCross');
  var elFoot = document.getElementById('cdFoot');

  function money(c) { return '$' + (c / 100).toFixed(2); }

  // colorway -> tin photo, for real image swatches
  var SWATCH_IMG = {};
  try { SWATCH_IMG = JSON.parse(document.getElementById('cd-swatch-imgs').textContent); } catch (e) {}
  function swatchDots(variants) {
    return variants.map(function (v, i) {
      var url = SWATCH_IMG[v.title] || '';
      var inner = url ? '<img src="' + url + '" alt="' + v.title + '">' : '';
      return '<button type="button" class="cd-sw' + (i === 0 ? ' is-sel' : '') + '" data-vid="' + v.id
        + '" data-name="' + v.title + '" title="' + v.title + '" aria-label="' + v.title + '">' + inner + '</button>';
    }).join('');
  }

  function openDrawer() {
    drawer.hidden = false; overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { drawer.classList.add('is-open'); overlay.classList.add('is-open'); });
  }
  function closeDrawer() {
    drawer.classList.remove('is-open'); overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; overlay.hidden = true; }, 320);
  }

  // ---- unified cart-aware deal message (same brain everywhere) ----
  function dealMsg(count) {
    if (count >= 3) {
      return '<p class="cd-r-msg cd-r-won">Your free tin and free shipping are locked in. Add more anytime.</p>'
        + '<div class="cd-r-track"><div class="cd-r-fill" style="width:100%"></div></div>';
    }
    if (count === 2) {
      return '<p class="cd-r-msg cd-r-won">Unlocked. Your 3rd tin is FREE. Pick any color below, it is on us.</p>'
        + '<div class="cd-r-track"><div class="cd-r-fill" style="width:100%"></div></div>';
    }
    return '<p class="cd-r-msg">Add <strong>1 more</strong> to unlock your free tin. Your 3rd is on us.</p>'
      + '<div class="cd-r-track"><div class="cd-r-fill" style="width:50%"></div></div>';
  }

  function itemHTML(item) {
    // Custom tins attach a rendered preview of the buyer's own design; show that instead of the product photo.
    var previewUrl = (item.properties && item.properties._Preview) ? item.properties._Preview : '';
    var thumb = previewUrl || item.image;
    var img = thumb ? '<img src="' + thumb + '" alt="">' : '<span></span>';
    // small color swatch next to the name so the chosen color is clear (product photo stays the thumbnail)
    var vswatch = SWATCH_IMG[item.variant_title] || '';
    var variant = (item.variant_title && !/default/i.test(item.variant_title))
      ? '<p class="cd-i-var">' + (vswatch ? '<img class="cd-i-swatch" src="' + vswatch + '" alt="">' : '') + item.variant_title + '</p>'
      : '';
    var added = item.variant_id === lastAddedId;
    var addedCls = added ? ' cd-item--added' : '';
    var addedTag = added ? '<span class="cd-i-just">Just added</span>' : '';
    // Show the real allocation: the free (cheapest) tin reads FREE and stands out;
    // every other line shows its own price, with the compare-at markdown struck through.
    var cmp = compareOf(item);
    var priceHTML;
    var isFreeLine = dealActive && item.final_line_price === 0;
    if (isFreeLine) {
      var wasFree = (cmp || item.price) * item.quantity;
      priceHTML = '<span class="cd-i-price cd-i-price--free"><span class="cd-i-free">FREE</span><s class="cd-i-was">' + money(wasFree) + '</s></span>';
    } else if (item.final_line_price < item.original_line_price) {
      // a line with more than one tin where one of them is the free tin
      priceHTML = '<span class="cd-i-price cd-i-price--sale"><s class="cd-i-was">' + money(item.original_line_price) + '</s><span class="cd-i-now">' + money(item.final_line_price) + '</span></span>';
    } else if (cmp) {
      priceHTML = '<span class="cd-i-price cd-i-price--sale"><s class="cd-i-was">' + money(cmp * item.quantity) + '</s><span class="cd-i-now">' + money(item.final_line_price) + '</span></span>';
    } else {
      priceHTML = '<span class="cd-i-price">' + money(item.final_line_price) + '</span>';
    }
    return '<div class="cd-item' + addedCls + '" data-key="' + item.key + '">' + img
      + '<div><p class="cd-i-title">' + item.product_title + '</p>' + variant + addedTag
      + '<div class="cd-qty"><button type="button" data-cd-dec aria-label="Decrease">&minus;</button><span>' + item.quantity + '</span><button type="button" data-cd-inc aria-label="Increase">+</button></div>'
      + ((item.properties && item.properties.Artwork) ? '' : '<button type="button" class="cd-i-edit" data-cd-edit>Edit color</button>') + '</div>'
      + '<div class="cd-i-right">' + priceHTML
      + '<button type="button" class="cd-i-remove" data-cd-remove>Remove</button></div></div>';
  }

  function crossHTML(cart) {
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = true; });
    var picks = cross.filter(function (p) { return !inCart[p.id]; }).slice(0, 3);
    if (!picks.length) return '';
    var isFree = cart.item_count === 2;
    var heading = isFree ? 'Pick your free 3rd tin' : 'Add more to your order';
    var subhead = isFree ? 'Your 3rd tin is on us, these are not in your cart yet.' : 'These are not in your cart yet. Tap Add to include one.';
    var cards = picks.map(function (p) {
      var avail = (p.variants || []).filter(function (v) { return v.available; });
      if (!avail.length) return '';
      var dots = swatchDots(avail);
      var firstName = avail[0].title;
      var addLabel = isFree ? 'Add free' : 'Add';
      return '<div class="cd-x-card">'
        + '<a class="cd-x-media" href="/products/' + (p.handle || '') + '">' + (p.img ? '<img src="' + p.img + '" alt="">' : '<span></span>') + '</a>'
        + '<div class="cd-x-info"><p class="cd-x-title">' + p.title + '</p>'
        + '<p class="cd-x-price">' + (isFree ? '<span class="cd-x-free">FREE</span> <s>' + money(p.price) + '</s>' : money(p.price)) + '</p>'
        + '<div class="cd-sw-row">' + dots + '</div>'
        + '<p class="cd-x-picked">Color: <strong>' + firstName + '</strong></p>'
        + '<button type="button" class="cd-x-add" data-cd-add data-vid="' + avail[0].id + '">' + addLabel + '</button>'
        + '</div></div>';
    }).join('');
    return '<p class="cd-x-head">' + heading + '</p><p class="cd-x-subhead">' + subhead + '</p>' + cards
      + '<a class="cd-x-all" href="/collections/all">See all Editions and colors &rarr;</a>';
  }

  function render(cart) {
    currentCart = cart;
    Array.prototype.forEach.call(document.querySelectorAll('.js-cart-count'), function (el) { el.textContent = cart.item_count; });
    Array.prototype.forEach.call(document.querySelectorAll('.js-cart-badge'), function (el) { el.hidden = (cart.item_count === 0); });
    // keep any on-page deal line in sync (e.g., the product page offer)
    Array.prototype.forEach.call(document.querySelectorAll('.js-deal-line'), function (el) { el.innerHTML = onPageDeal(cart.item_count, el); });

    if (cart.item_count === 0) {
      elReward.innerHTML = '';
      elItems.innerHTML = '';
      elCross.innerHTML = '';
      elFoot.innerHTML = '<p class="cd-empty">Your cart is empty.</p><a href="' + '/collections/all" class="btn btn-brass" data-cd-close>Shop the Editions</a>';
      return;
    }
    dealActive = cart.total_discount > 0;
    dealPer = cart.item_count ? Math.round(cart.total_price / cart.item_count) : 0;

    elReward.innerHTML = dealMsg(cart.item_count);
    elItems.innerHTML = cart.items.map(itemHTML).join('');
    elCross.innerHTML = crossHTML(cart);
    // "Was" = sum of compare-at prices (falls back to unit price when none set),
    // so the markdown shows at every quantity, plus any Buy 2 Get 1 saving.
    var wasTotal = 0;
    cart.items.forEach(function (i) { var c = compareOf(i); wasTotal += (c || i.price) * i.quantity; });
    var save = wasTotal - cart.total_price;
    var hasSave = save > 0;
    var saved = hasSave
      ? '<p class="cd-saved">You save ' + money(save) + (cart.total_discount > 0 ? ' &middot; includes your free tin' : '') + '</p>'
      : '';
    // effective per-tin once the free-tin deal is live
    var perTin = dealActive ? '<p class="cd-pertin">That’s just <strong>' + money(dealPer) + '</strong> per tin</p>' : '';
    var amount = hasSave
      ? '<span class="cd-sub-amt"><s class="cd-was">' + money(wasTotal) + '</s><span class="cd-now cd-now--sale">' + money(cart.total_price) + '</span></span>'
      : '<span class="cd-sub-amt"><span class="cd-now">' + money(cart.total_price) + '</span></span>';
    // At exactly 2 tins the free 3rd is one tap away -> make picking it the primary action.
    var cta = cart.item_count === 2
      ? '<button type="button" class="btn btn-brass cd-checkout" data-cd-pick>Pick your FREE 3rd tin <span class="arw">&darr;</span></button>'
        + '<a href="/checkout" class="cd-skip">Check out without it</a>'
      : '<a href="/checkout" class="btn btn-brass cd-checkout">Checkout &middot; ' + money(cart.total_price) + ' <span class="arw">&rarr;</span></a>';
    elFoot.innerHTML = saved + perTin
      + '<div class="cd-sub"><span>Total</span>' + amount + '</div>'
      + cta
      + '<p class="cd-foot-note">Free shipping over $35 &middot; taxes at checkout</p>';
  }

  // cart-aware one-liner reused on product pages
  function onPageDeal(count, el) {
    if (count >= 3) return 'Your free tin and free shipping are locked in. Add more anytime.';
    if (count === 2) return 'Unlocked. Your 3rd tin is FREE. Pick any color and add it, it is on us.';
    if (count === 1) return 'Add 1 more to unlock your free tin. Your 3rd is on us.';
    // Empty cart: on a single product (PDP) show that product's own per-tin math,
    // read from data attributes so nothing is hardcoded. Elsewhere, stay generic.
    var unit = el && el.getAttribute('data-deal-unit');
    var three = el && el.getAttribute('data-deal-three');
    if (unit && three) {
      return 'Get your 3rd tin free. Buy 2, get 1 free, mix any colors or Editions. Three tins for ' + three + ', just ' + unit + ' each. Free shipping over $35.';
    }
    return 'Get your 3rd tin free. Buy 2, get 1 free, mix any colors or Editions. Free shipping over $35.';
  }

  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(c); return c; });
  }
  function change(key, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(function (c) { render(c); });
  }
  function addVariant(vid) {
    lastAddedId = Number(vid);
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: Number(vid), quantity: 1 }) })
      .then(function () { return refresh(); }).then(scrollToAdded);
  }
  function scrollToAdded() {
    var el = drawer.querySelector('.cd-item--added');
    if (el && el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
  }

  // ---- Quick-edit popup: change an item's color or quantity in place ----
  var editEl = document.createElement('div');
  editEl.className = 'cd-edit';
  editEl.hidden = true;
  editEl.innerHTML =
    '<div class="cd-edit-panel">' +
      '<button type="button" class="cd-edit-x" data-cd-edit-cancel aria-label="Close">&times;</button>' +
      '<p class="cd-edit-title"></p>' +
        '<p class="cd-edit-lbl cd-edit-slots-lbl" hidden>Pick a color for each tin</p>' +
        '<div class="cd-edit-slots" hidden></div>' +
      '<div class="cd-edit-colorwrap">' +
        '<p class="cd-edit-lbl">Color: <strong class="cd-edit-color"></strong></p>' +
        '<div class="cd-sw-row cd-edit-swrow"></div>' +
      '</div>' +
      '<p class="cd-edit-lbl cd-edit-qlbl">Quantity</p>' +
      '<div class="cd-qty cd-edit-qty"><button type="button" data-cd-edit-dec aria-label="Decrease">&minus;</button><span class="cd-edit-qnum">1</span><button type="button" data-cd-edit-inc aria-label="Increase">+</button></div>' +
      '<button type="button" class="btn btn-brass cd-edit-update" data-cd-edit-update>Update</button>' +
    '</div>';
  drawer.appendChild(editEl);
  var editTitle = editEl.querySelector('.cd-edit-title');
  var editColorWrap = editEl.querySelector('.cd-edit-colorwrap');
  var editColorName = editEl.querySelector('.cd-edit-color');
  var editSwRow = editEl.querySelector('.cd-edit-swrow');
  var editQnum = editEl.querySelector('.cd-edit-qnum');
  var editSlots = editEl.querySelector('.cd-edit-slots');
  var editSlotsLbl = editEl.querySelector('.cd-edit-slots-lbl');
  var editQlbl = editEl.querySelector('.cd-edit-qlbl');
  var editQty = editEl.querySelector('.cd-edit-qty');
  var editState = null;

  function productForItem(item) {
    for (var i = 0; i < cross.length; i++) { if (cross[i].id === item.product_id) return cross[i]; }
    return null;
  }
  function openEdit(key) {
    if (!currentCart) return;
    var item = null;
    for (var i = 0; i < currentCart.items.length; i++) { if (currentCart.items[i].key === key) { item = currentCart.items[i]; break; } }
    if (!item) return;
    // Per-tin colors for THIS line only, so the number of pickers matches the
    // quantity shown on the line (the Buy-2-Get-1 free tin is its own line).
    editState = { key: key, vid: item.variant_id, qty: item.quantity, productKeys: [key] };
    editTitle.textContent = item.product_title;
    editQnum.textContent = item.quantity;
    var p = productForItem(item);
    var avail = p ? (p.variants || []).filter(function (v) { return v.available; }) : [];
    function swHTML(selVid) {
      return avail.map(function (v) {
        var url = SWATCH_IMG[v.title] || '';
        return '<button type="button" class="cd-sw' + (v.id === selVid ? ' is-sel' : '') + '" data-vid="' + v.id + '" data-name="' + v.title + '">' + (url ? '<img src="' + url + '" alt="' + v.title + '">' : '') + '</button>';
      }).join('');
    }
    var perTin = avail.length > 1 && item.quantity > 1;
    editState.perTin = perTin;
    if (perTin) {
      // one color picker per tin on this line
      var slotsHTML = '';
      for (var n = 1; n <= item.quantity; n++) {
        slotsHTML += '<div class="cd-edit-slot">' +
          '<p class="cd-edit-slbl">Tin ' + n + ': <strong class="cd-edit-sname">' + (item.variant_title || '') + '</strong></p>' +
          '<div class="cd-sw-row cd-edit-srow">' + swHTML(item.variant_id) + '</div>' +
        '</div>';
      }
      editSlots.innerHTML = slotsHTML;
      editSlots.hidden = false; editSlotsLbl.hidden = false;
      editColorWrap.hidden = true;
      editQlbl.hidden = true; editQty.hidden = true;
    } else if (avail.length > 1) {
      editSwRow.innerHTML = swHTML(item.variant_id);
      var cur = avail.filter(function (v) { return v.id === item.variant_id; })[0];
      editColorName.textContent = cur ? cur.title : (item.variant_title || '');
      editColorWrap.hidden = false;
      editSlots.hidden = true; editSlotsLbl.hidden = true;
      editQlbl.hidden = false; editQty.hidden = false;
    } else {
      editSwRow.innerHTML = '';
      editColorWrap.hidden = true;
      editSlots.hidden = true; editSlotsLbl.hidden = true;
      editQlbl.hidden = false; editQty.hidden = false;
    }
    editEl.hidden = false;
    requestAnimationFrame(function () { editEl.classList.add('is-open'); });
  }
  function closeEdit() {
    editEl.classList.remove('is-open');
    setTimeout(function () { editEl.hidden = true; }, 250);
    editState = null;
  }
  function applyEdit() {
    if (!editState) return;
    if (editState.perTin) {
      // gather each tin's chosen colorway, group identical ones, then rebuild the line(s)
      var picks = [];
      Array.prototype.forEach.call(editSlots.querySelectorAll('.cd-edit-slot'), function (slot) {
        var s = slot.querySelector('.cd-sw.is-sel');
        picks.push(s ? Number(s.getAttribute('data-vid')) : editState.vid);
      });
      var counts = {};
      picks.forEach(function (v) { counts[v] = (counts[v] || 0) + 1; });
      var addItems = Object.keys(counts).map(function (v) { return { id: Number(v), quantity: counts[v] }; });
      lastAddedId = picks[0];
      var updates = {};
      (editState.productKeys || [editState.key]).forEach(function (k) { updates[k] = 0; });
      closeEdit();
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
        .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: addItems }) }); })
        .then(function () { return refresh(); });
      return;
    }
    var sel = editSwRow.querySelector('.cd-sw.is-sel');
    var newVid = sel ? Number(sel.getAttribute('data-vid')) : editState.vid;
    var newQty = Math.max(1, parseInt(editQnum.textContent, 10) || 1);
    var key = editState.key;
    var oldVid = editState.vid;
    closeEdit();
    if (newVid === oldVid) {
      change(key, newQty);
      return;
    }
    // color changed: drop the old line, add the chosen colorway at the same qty
    lastAddedId = newVid;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) })
      .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: newVid, quantity: newQty }) }); })
      .then(function () { return refresh(); });
  }

  // delegated events in the drawer
  drawer.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-cd-close]')) { closeDrawer(); return; }
    if (t.closest('[data-cd-pick]')) {
      if (elCross) elCross.scrollIntoView({ behavior: 'smooth', block: 'start' });
      elCross.classList.add('cd-cross--flash');
      setTimeout(function () { elCross.classList.remove('cd-cross--flash'); }, 1400);
      return;
    }
    // quick-edit popup controls
    if (t.closest('[data-cd-edit-cancel]')) { closeEdit(); return; }
    if (editEl.contains(t) && t === editEl) { closeEdit(); return; } // click on backdrop
    if (t.closest('[data-cd-edit-inc]')) { editQnum.textContent = (parseInt(editQnum.textContent, 10) || 1) + 1; return; }
    if (t.closest('[data-cd-edit-dec]')) { editQnum.textContent = Math.max(1, (parseInt(editQnum.textContent, 10) || 1) - 1); return; }
    if (t.closest('[data-cd-edit-update]')) { applyEdit(); return; }
    // pick a colorway swatch on a cross-sell card OR in the edit popup
    var sw = t.closest('.cd-sw');
    if (sw) {
      var row = sw.closest('.cd-sw-row');
      Array.prototype.forEach.call(row.querySelectorAll('.cd-sw'), function (b) { b.classList.remove('is-sel'); });
      sw.classList.add('is-sel');
      var info = sw.closest('.cd-x-info');
      var pick = info ? info.querySelector('.cd-x-picked strong') : null;
      if (pick) pick.textContent = sw.getAttribute('data-name');
      if (editColorName && sw.closest('.cd-edit')) editColorName.textContent = sw.getAttribute('data-name');
      var eslot = sw.closest('.cd-edit-slot');
      if (eslot) { var sn = eslot.querySelector('.cd-edit-sname'); if (sn) sn.textContent = sw.getAttribute('data-name'); }
      return;
    }
    var itemEl = t.closest('.cd-item[data-key]');
    if (itemEl) {
      var key = itemEl.getAttribute('data-key');
      if (t.closest('[data-cd-edit]')) { openEdit(key); return; }
      if (t.closest('[data-cd-remove]')) { change(key, 0); return; }
      var qEl = itemEl.querySelector('.cd-qty span');
      if (qEl) {
        var q = parseInt(qEl.textContent, 10);
        if (t.closest('[data-cd-inc]')) { change(key, q + 1); return; }
        if (t.closest('[data-cd-dec]')) { change(key, Math.max(0, q - 1)); return; }
      }
    }
    var addBtn = t.closest('[data-cd-add]');
    if (addBtn) {
      var card = addBtn.closest('.cd-x-card');
      var chosen = card ? card.querySelector('.cd-sw.is-sel') : null;
      var vid = chosen ? chosen.getAttribute('data-vid') : addBtn.getAttribute('data-vid');
      addBtn.disabled = true; addBtn.textContent = 'Added';
      addVariant(vid);
      return;
    }
  });
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) closeDrawer(); });

  // cart icon opens the drawer instead of navigating
  Array.prototype.forEach.call(document.querySelectorAll('.js-cart-toggle'), function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); refresh(); });
  });

  // intercept every add-to-cart on the site -> AJAX add -> open the drawer
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var action = form && form.getAttribute ? (form.getAttribute('action') || '') : '';
    if (action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var fd = new FormData(form);
    var addedId = fd.get('id'); if (addedId) lastAddedId = Number(addedId);
    fetch('/cart/add.js', { method: 'POST', body: fd })
      .then(function () { return refresh(); })
      .then(function () { openDrawer(); scrollToAdded(); })
      .catch(function () { form.submit(); });
  });

  refresh();   // populate on load (count badge, on-page deal line)
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();

/* ============================================================
   COLLECTION / CARD colorway picker (add-to-cart happens via the
   global submit interceptor above, which opens the drawer)
   ============================================================ */
(function () {
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.ec-sw');
    if (!sw) return;
    var form = sw.closest('.ec-add');
    if (!form) return;
    Array.prototype.forEach.call(form.querySelectorAll('.ec-sw'), function (b) { b.classList.remove('is-sel'); });
    sw.classList.add('is-sel');
    var idInput = form.querySelector('.ec-id');
    if (idInput) idInput.value = sw.getAttribute('data-vid');
    var name = form.querySelector('.ec-picked-name');
    if (name) name.textContent = sw.getAttribute('data-name');
  });
})();
